import api from './api';

class LanguageService {

  get() {
    return api.get("languages").then(response => {
        return response.data.elements;
      })
  }

}

export default new LanguageService();